import React from 'react';
import { Crown, X, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Banner shown at the very top of the dashboard when a super_admin has
 * "entered" the context of an OF via SuperAdmin > "Accéder".
 *
 * Renders nothing for regular tenant users.
 *
 * Two CTAs:
 *  - "Retour au super admin" → exits the acting context AND navigates to /superadmin
 *  - "Quitter ce mode"        → exits acting only (stay on current page)
 */
export default function ActingOrgBanner() {
  const { user, actingOrg, clearActingOrg } = useAuth();
  const navigate = useNavigate();
  if (!actingOrg) return null;

  const role = (user?.role || '').toLowerCase().replace(' ', '_');
  const isSuperAdmin = role === 'super_admin' || role === 'superadmin';
  if (!isSuperAdmin) return null;

  const goBackToSuperAdmin = () => {
    clearActingOrg();
    navigate('/superadmin');
  };
  const exitOnly = () => {
    clearActingOrg();
  };

  return (
    <div
      data-testid="acting-org-banner"
      className="bg-gradient-to-r from-[#4F46E5] to-[#5B3FE0] text-white px-6 py-2.5 flex items-center justify-between gap-3 shadow-md sticky top-0 z-30"
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <Crown className="w-4 h-4 shrink-0" />
        <span className="text-[12.5px] font-semibold whitespace-nowrap">Mode super admin actif</span>
        <span className="text-[12.5px] opacity-80 hidden sm:inline">·</span>
        <span className="text-[12.5px] truncate">
          Vous gérez l'OF <span className="font-bold">{actingOrg.name}</span>
          <span className="opacity-70 font-mono ml-1.5">({actingOrg.org_id})</span>
        </span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          data-testid="acting-org-back"
          onClick={goBackToSuperAdmin}
          className="h-7 px-2.5 rounded-md bg-white/15 hover:bg-white/25 text-[11.5px] font-semibold inline-flex items-center gap-1 transition-colors"
        >
          <ArrowLeft className="w-3 h-3" /> Retour super admin
        </button>
        <button
          data-testid="acting-org-exit"
          onClick={exitOnly}
          title="Quitter le mode super admin (rester ici)"
          className="w-7 h-7 rounded-md hover:bg-white/15 inline-flex items-center justify-center transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
